import Store from 'store';
import { getStats, getLastStats } from 'logic/stats';

export function addActive(type, id, info) {
  let curIdx = 0;
  const defaultValues = [];

  function selectState(state) {
    let params;
    if (type === "party") {
      params = state.profiles[state.activeProfile].active;
    } else {
      params = state.active;
    }
    return params && params[id];
  }

  if (info.active !== undefined) {
    const idxActive = curIdx++;
    const defaultValue = info.active ? 1 : 0;
    defaultValues.push(defaultValue);
    info.selectActive = function(state) {
      state = selectState(state);
      if (!state || state[idxActive] === undefined) {
        return !!defaultValue;
      }
      return !!state[idxActive];
    };
    info.setActive = function(dispatch, value) {
      if (type === "party") {
        dispatch = dispatch.profile;
      }
      dispatch.setActive(id, active => {
        active = active || defaultValues;
        active = active.slice();
        active[idxActive] = value ? 1 : 0;
        return active;
      });
    };

    Object.defineProperty(info, "active", {
      get() {
        const state = Store.instance.getState();
        return info.selectActive(state);
      }
    });
  } else {
    info.selectActive = () => undefined;
  }

  if (info.params) {
    const idxParams = curIdx++;
    const values = info.params.map((param, index) => {
      if (param.selectValue) return param.initValue;

      param.dynamic = isNaN(param.min) || isNaN(param.max);

      param.initValue = (param.val == null ? "max" : param.val);
      if (isNaN(param.initValue) && !param.dynamic) {
        if (param.initValue === "max") param.initValue = param.max;
        else param.initValue = param.min;
      }

      function selectValue(state) {
        const params = selectState(state);
        if (!params || typeof params[idxParams] !== "object") {
          return param.initValue;
        }
        const value = params[idxParams][index];
        return value == null ? param.initValue : value;
      }

      function getValue(stats, value) {
        const getValue = arg => {
          if (typeof arg === "string") {
            return stats.execString(arg);
          } else if (typeof arg === "function") {
            return arg.call(info, stats);
          } else {
            return arg;
          }
        };
        const result = {
          step: getValue(param.step) || 1,
          min: getValue(param.min),
          max: getValue(param.max),
          inf: !!getValue(param.inf),
          name: (typeof param.name === "function" ? param.name() : param.name),
        };
        result.min = Math.ceil(result.min / result.step) * result.step;
        result.max = Math.floor(result.max / result.step) * result.step;
        //if (result.inf && !isNaN(value)) {
        //  const lim = (value - result.min) * 1.33 + result.min;
        //  result.max = Math.max(result.max, Math.floor(lim / result.step) * result.step);
        //}
        if (isNaN(value)) {
          if (value === "min") {
            result.val = result.min;
          } else {
            result.val = result.max;
          }
        } else {
          result.val = value;
        }
        result.val = Math.max(result.min, result.val);
        if (!result.inf) {
          result.val = Math.min(result.max, result.val);
        }
        return result;
      };
      param.selectValue = function(state) {
        const stats = getStats(state);
        const value = selectValue(state);
        return getValue(stats, value);
      };
      param.setValue = function(dispatch, value) {
        if (type === "party") {
          dispatch = dispatch.profile;
        }
        dispatch.setActive(id, active => {
          active = active || defaultValues;
          active = active.slice();
          active[idxParams] = active[idxParams]?.slice() || [];
          active[idxParams][index] = value;
          return active;
        });
      };

      Object.defineProperty(param, "val", {
        get() {
          const state = Store.instance.getState();
          const value = selectValue(state);
          return getValue(getLastStats(), value).val;
        }
      });

      return param.initValue;
    });
    defaultValues.push(values);
  }

  if (info.boxnames) {
    const idxBoxes = curIdx++;
    const defaultValue = info.boxnames.map(() => false);
    defaultValues.push(defaultValue);

    info.selectBoxes = function(state) {
      state = selectState(state);
      if (!state || typeof state[idxBoxes] !== "object") {
        return defaultValue;
      }
      return state[idxBoxes];
    };
    info.setBoxValue = function(dispatch, index, value) {
      if (type === "party") {
        dispatch = dispatch.profile;
      }
      dispatch.setActive(id, active => {
        active = active || defaultValues;
        active = active.slice();
        active[idxBoxes] = active[idxBoxes]?.slice() || [];
        active[idxBoxes][index] = value ? 1 : 0;
        return active;
      });
    };

    Object.defineProperty(info, "boxvals", {
      get() {
        const state = Store.instance.getState();
        return info.selectBoxes(state);
      }
    });
  }

  if (info.runelist) {
    const idxRunes = curIdx++;
    let defaultValue;
    if (info.multiple) {
      defaultValue = {};
      for (const id in info.runes) {
        defaultValue[id] = 0;
      }

      info.selectRunes = function(state) {
        state = selectState(state);
        state = state && state[idxRunes];
        if (typeof state !== "object") {
          state = defaultValue;
        }
        return state;
      };
      info.setRuneValue = function(dispatch, rune, value) {
        if (type === "party") {
          dispatch = dispatch.profile;
        }
        dispatch.setActive(id, active => {
          active = active || defaultValues;
          active = active.slice();
          active[idxRunes] = {...active[idxRunes]};
          active[idxRunes][rune] = value ? 1 : 0;
          return active;
        });
      };
    } else {
      defaultValue = (info.runelist === "*" ? "x" : info.runelist[0]);

      info.selectRunes = function(state) {
        state = selectState(state);
        state = state && state[idxRunes];
        return state || defaultValue;
      };
      info.setRuneValue = function(dispatch, value) {
        if (type === "party") {
          dispatch = dispatch.profile;
        }
        dispatch.setActive(id, active => {
          active = active || defaultValues;
          active = active.slice();
          active[idxRunes] = value;
          return active;
        });
      };
      info.runevals = (info.runelist === "*" ? "x" : info.runelist[0]);
    }
    defaultValues.push(defaultValue);
    Object.defineProperty(info, "runevals", {
      get() {
        const state = Store.instance.getState();
        return info.selectRunes(state);
      }
    });
  }
};
